import type { Toast } from "@store/slices/toast";

export const toastSelector = (state): Toast => state.toast;
